import React from 'react';
import { FormikProps } from 'formik';
import { UpdateDepositValues, VehicleType, VehicleVersionBodyFields, VehicleVersionStateFields } from 'types';
import { VehicleStateFormView } from './VehicleStateFormView';
import { VehicleBodyFormView } from './VehicleBodyFormView';
import { vehicleVersionBodyFieldsList } from './VehicleVersionForm';
import { useApp } from '../../providers';

export type UpdateVehicleVersionProps = VehicleVersionStateFields & VehicleVersionBodyFields;

export type Props = FormikProps<UpdateDepositValues> & {
  vehicleType: VehicleType;
  updatedFields: Record<keyof UpdateVehicleVersionProps, boolean>;
};

export const UpdateVehicleVersionForm: React.FC<Props> = ({
  vehicleType,
  updatedFields,
  values,
  touched,
  errors,
  setFieldValue,
  handleBlur,
  handleChange,
}) => {
  const { user } = useApp();

  return (
    <>
      <VehicleStateFormView
        values={values}
        updatedFields={updatedFields}
        touched={touched}
        errors={errors}
        setFieldValue={setFieldValue}
        isPro={user?.isPro}
        handleBlur={handleBlur}
      />
      <VehicleBodyFormView
        vehicleType={vehicleType}
        vehicleVersionBodyFieldsList={vehicleVersionBodyFieldsList}
        values={values}
        updatedFields={updatedFields}
        touched={touched}
        errors={errors}
        handleBlur={handleBlur}
        handleChange={handleChange}
      />
    </>
  );
};
